import { render, staticRenderFns } from "./QuickpickMobile.vue?vue&type=template&id=15485bdf&scoped=true"
import script from "./QuickpickMobile.vue?vue&type=script&lang=js"
export * from "./QuickpickMobile.vue?vue&type=script&lang=js"
import style0 from "./QuickpickMobile.vue?vue&type=style&index=0&id=15485bdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15485bdf",
  null
  
)

export default component.exports